export default __webpack_public_path__ + "images/logo-plain.svg?06c27dc28ddeb02afaa9b2dced262ffc";